import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useEffect } from 'react';
import I18n from 'I18n';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { formattedPaymentMethodLabel } from 'commerce-shared-components-lib/features/checkout/utils/formattedPaymentMethodLabel';
import { Link } from 'foundations-components/transitional/components/Link';
import { ChirpError, readUnhandledEnumCase } from 'rpc-client-utils';
import { useHistory } from 'quartz-routing/react-router';
import { useDeletePaymentMethodMutation } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/PublicBillingActionsRpc.hooks';
import { GET_PAYMENT_METHODS_QUERY } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.dfc.new';
import { Paths } from '../constants/Paths';
import { trackInteraction, trackPageView } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function isDeleteNotAllowedError(error) {
  var _networkError;
  const cause = error === null || error === void 0 || (_networkError = error.networkError) === null || _networkError === void 0 ? void 0 : _networkError.cause;
  if (cause instanceof ChirpError) {
    const rpcError = cause.cause;
    return (rpcError === null || rpcError === void 0 ? void 0 : rpcError.errorType) === 'PAYMENT_METHOD_DELETE_NOT_ALLOWED';
  }
  return false;
}
export function RemovePaymentMethodModal({
  paymentMethod,
  onClose
}) {
  const history = useHistory();
  useEffect(() => {
    trackPageView('remove-payment-method-modal');
  }, []);
  const {
    type,
    brand,
    last4
  } = paymentMethod.paymentMethodDetails;
  const paymentMethodLabel = formattedPaymentMethodLabel(readUnhandledEnumCase(type !== null && type !== void 0 ? type : ''), brand !== null && brand !== void 0 ? brand : undefined, last4 !== null && last4 !== void 0 ? last4 : undefined);
  const [deletePaymentMethod, {
    loading
  }] = useDeletePaymentMethodMutation({
    refetchQueries: [GET_PAYMENT_METHODS_QUERY],
    onCompleted: () => {
      trackInteraction('remove-payment-method-success');
      FloatingAlertStore.addAlert({
        message: I18n.text('paymentMethods.deleteModal.successMessage'),
        type: 'info'
      });
      onClose();
    },
    onError: error => {
      const message = isDeleteNotAllowedError(error) ? I18n.text('paymentMethods.deleteModal.errorNotAllowed') : I18n.text('paymentMethods.deleteModal.errorMessage');
      trackInteraction('remove-payment-method-error');
      FloatingAlertStore.addAlert({
        message,
        type: 'danger'
      });
    }
  });
  const handleDelete = () => {
    trackInteraction('remove-payment-method-initiated');
    void deletePaymentMethod({
      variables: {
        paymentMethodId: paymentMethod.objectId
      }
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    width: 515,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentMethods.deleteModal.title",
          options: {
            paymentMethodLabel
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [/*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "paymentMethods.deleteModal.description"
          })
        }), /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "paymentMethods.deleteModal.subscriptionNote_jsx",
            elements: {
              Link: _ref => {
                let {
                    children
                  } = _ref,
                  props = _objectWithoutPropertiesLoose(_ref, _excluded);
                return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
                  onClick: () => {
                    onClose();
                    history.push(Paths.SUBSCRIPTIONS);
                  },
                  children: children
                }));
              }
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        use: "danger",
        onClick: handleDelete,
        loading: loading,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentMethods.deleteModal.deleteButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary-ghost",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "paymentMethods.deleteModal.closeButton"
        })
      })]
    })]
  });
}